import { ApiClient } from '@rootsight/shared';

/**
 * The login SPA's API client. A 401 here is the expected state, not an event
 * to react to, so no onUnauthenticated handler is installed.
 */
export const api = new ApiClient();

/** Where to send an operator once they are authenticated. */
export const CONSOLE_URL = '/app/';
